import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { applePayApi } from '@api';
import native from '@native';
import Modal from '@root/components/modal';
// import Toast from '@root/components/toast';
import { APP_VERSION } from '@root/constant';
// import { isInApp, isIos } from '@root/shared';

const isApplePayVersion = (arr1: string[]) => {
  const arr2 = [1, 13];

  let pos = 0;
  let diff = 0;

  while (pos < 2 && diff === 0) {
    diff = parseInt(arr1[pos], 10) - arr2[pos];

    if (diff === 0) {
      pos++;
    }
  }

  return diff >= 0;
};

const useApplePayBtnAction = () => {
  // const [loading, setLoading] = useState(-1);
  const { t } = useTranslation();
  // const [canSubscribe, setCanSubscribe] = useState(false);
  const navigate = useNavigate();

  const _appVersion = localStorage.getItem(APP_VERSION) || '';

  const supportApplePayVersion = useMemo(() => {
    if (!_appVersion) {
      return false;
    }

    // '1.13.0-test.1';
    const _versions = _appVersion.split('-')[0]?.split('.') || [];

    if (!_versions.length) {
      return false;
    }

    return isApplePayVersion(_versions);
  }, [_appVersion]);

  // const checkCanSubscribe = useCallback(() => {
  //   setLoading(0);
  //   applePayApi
  //     .checkCanSubscribe()
  //     .then((data: any) => {
  //       setCanSubscribe(data?.canSubscribe === 1);
  //       setLoading(1);
  //     })
  //     .catch(() => {
  //       setLoading(2);
  //     });
  // }, []);

  const onApplePay = useCallback(() => {
    // Toast.destroy();
    if (!window.WebViewJavascriptBridge || !supportApplePayVersion) {
      Modal.confirm({
        content: t('app_version_not_support'),
        cancel: t('later'),
        confirm: t('update_now'),
        onConfirm: () => {
          if (window.WebViewJavascriptBridge) {
            native.system.openBrowser(
              'https://apps.apple.com/app/aidot/id1580685276',
            );
          }
        },
        // onCancel: () => {
        // },
      });
      return;
    }

    // if (loading < 1) {
    //   Toast.info(t('loading_now'));
    //   return;
    // }

    // if (loading === 2) {
    //   checkCanSubscribe();
    //   Toast.info(t('check_products_error'));
    //   return;
    // }

    // if (!canSubscribe) {
    //   // Already have a subscription.
    //   // Please go to iphone settings,check your account.
    //   Modal.alert({
    //     title: t('apple_pay_subscribed_tips_1'),
    //     content: t('apple_pay_subscribed_tips_2'),
    //     confirm: t('ok'),
    //   });
    //   return;
    // }

    navigate('/applePay');
  }, [navigate, supportApplePayVersion, t]);

  // useEffect(() => {
  //   if (
  //     isInApp &&
  //     isIos &&
  //     window.WebViewJavascriptBridge &&
  //     supportApplePayVersion
  //   ) {
  //     checkCanSubscribe();
  //   }
  // }, [checkCanSubscribe, supportApplePayVersion]);

  useEffect(() => {
    return () => {
      Modal.close();
      // Toast.destroy();
    };
  }, []);

  return onApplePay;
};

export default useApplePayBtnAction;
